module.exports = __webpack_public_path__ + "img/i1.0ffef749.png";